import React, { useState } from "react";

function PdfTutorialModal({ isOpen, onClose }) {

  const [page, setPage] = useState(1);
  const totalPages = 22;

  const nextPage = () => {
    if (page < totalPages) {
      setPage(page + 1);
    } else {
      onClose();
    }
  };

  const prevPage = () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };

  if (!isOpen) return null;

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <div style={headerStyle}>
          <button onClick={onClose} style={closeBtn}>✕</button>
        </div>

        <p style={{marginBottom:"10px"}}>
          Page {page} of {totalPages}
        </p>

        <iframe
          src={`/admin-crm-user-guide.pdf#page=${page}&toolbar=0&navpanes=0&scrollbar=0`}
          title="PDF Guide"
          width="100%"
          height="500px"
          style={{ border: "1px solid #eee", borderRadius:"6px"}}
        />
        <div style={buttonContainer}>
          <button
            onClick={onClose}
            style={skipBtn}
          >
            Skip
          </button>

        </div>

      </div>
    </div>
  );
}

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(0,0,0,0.6)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1000
};

const modalStyle = {
  background: "#fff",
  padding: "25px",
  borderRadius: "10px",
  width: "85%",
  maxWidth: "950px",
  boxShadow: "0 10px 40px rgba(0,0,0,0.2)"
};

const headerStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "10px"
};

const closeBtn = {
  border: "none",
  background: "transparent",
  fontSize: "20px",
  cursor: "pointer"
};

const progressContainer = {
  height: "6px",
  background: "#eee",
  borderRadius: "4px",
  marginBottom: "10px"
};

const progressBar = {
  height: "100%",
  background: "#4f46e5",
  borderRadius: "4px",
  transition: "0.3s"
};

const buttonContainer = {
  marginTop: "20px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center"
};

const primaryBtn = {
  background: "#4f46e5",
  color: "#fff",
  border: "none",
  padding: "10px 20px",
  borderRadius: "6px",
  cursor: "pointer",
  fontWeight: "500"
};

const secondaryBtn = {
  background: "#f1f1f1",
  border: "none",
  padding: "10px 20px",
  borderRadius: "6px",
  cursor: "pointer"
};

const skipBtn = {
  background: "transparent",
  border: "none",
  color: "#666",
  cursor: "pointer"
};

export default PdfTutorialModal;